<template>
  <div class="report-metadata" v-if="metadata && metadata.filterScopeLabel">
    <span class="label label-info">{{ metadata.filterScopeLabel }}</span>
  </div>
</template>

<script>
  export default {
    name: 'ReportFilterBadge',
    props: {
      metadata: {
        type: Object,
        default: null
      }
    }
  }
</script>

<style scoped>
  .report-metadata {
    margin-bottom: 8px;
    text-align: center;
  }
  .label {
    font-size: 12px;
    font-weight: normal;
    white-space: normal;
    display: inline-block;
    line-height: 1.4;
  }
</style>



// WEBPACK FOOTER //
// ReportFilterBadge.vue?3e380a0e